import { useState, useEffect } from 'react';
import { Modal, notification } from 'antd';
import axios from 'axios';
import { baseUrl, rozerpay_key_id } from '../../../config';
import { M, G } from '../shared/constants';
import { authHeader, useLang, playNotifSound } from '../shared/utils';

const FLOWERS = ['🌸','🌺','🌼','🌻','🎊','🎉','🌷','✨','🌸','🎈','🌺','🌼','🎊','🌸','🎉','🌷','✨','🌸','🌺','🎈'];

export function ReferrerPromptModal({ profile, onClose, onDone }) {
  const [searchQ,     setSearchQ]     = useState('');
  const [searchRes,   setSearchRes]   = useState([]);
  const [searching,   setSearching]   = useState(false);
  const [selected,    setSelected]    = useState(null);
  const [note,        setNote]        = useState('');
  const [sending,     setSending]     = useState(false);
  const debRef = useState(null);

  const search = (val) => {
    setSearchQ(val); setSelected(null);
    if (debRef[0]) clearTimeout(debRef[0]);
    if (!val.trim()) { setSearchRes([]); return; }
    setSearching(true);
    debRef[0] = setTimeout(async () => {
      try {
        const r = await axios.get(`${baseUrl}/member/member-search?search=${encodeURIComponent(val)}&limit=8`, { headers: authHeader() });
        setSearchRes((r.data.result || []).filter(m => m.id !== profile?.id));
      } catch {} finally { setSearching(false); }
    }, 400);
  };

  const send = async () => {
    if (!selected) return;
    setSending(true);
    try {
      const res = await axios.post(`${baseUrl}/member/referral-request`, { to_user_id: selected.id, message: note }, { headers: authHeader() });
      if (res.data.status) {
        notification.success({ message: res.data.message, placement: 'topRight' });
        onDone();
      }
    } catch (err) {
      notification.error({ message: err.response?.data?.message || 'कुछ समस्या हुई', placement: 'topRight' });
    } finally { setSending(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9998, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div style={{ background: '#fff', width: '100%', maxWidth: 480, borderRadius: '18px 18px 0 0', padding: '20px 18px 32px', boxShadow: '0 -8px 30px rgba(0,0,0,0.2)' }}>
        {/* Handle */}
        <div style={{ width: 40, height: 4, background: '#e5e7eb', borderRadius: 4, margin: '0 auto 18px' }} />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 800, color: '#111827' }}>किसने आपको जोड़ा?</div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 3 }}>जिस सदस्य ने आपको ABRSVS से जोड़ा, उन्हें यहाँ जोड़ें</div>
          </div>
          <button onClick={onClose} style={{ background: '#f3f4f6', border: 'none', borderRadius: '50%', width: 28, height: 28, fontSize: 14, cursor: 'pointer', color: '#6b7280', flexShrink: 0 }}>✕</button>
        </div>

        {/* Search */}
        <div style={{ position: 'relative', marginBottom: 12 }}>
          <input value={searchQ} onChange={e => search(e.target.value)}
            placeholder="सदस्य का नाम लिखें…"
            style={{ width: '100%', border: '1.5px solid #d1d5db', borderRadius: 10, padding: '10px 14px', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
            autoFocus
          />
          {searching && <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>खोज रहे हैं…</div>}
          {searchRes.length > 0 && !selected && (
            <div style={{ position: 'absolute', zIndex: 999, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, boxShadow: '0 6px 20px rgba(0,0,0,0.12)', top: '100%', left: 0, right: 0, maxHeight: 200, overflowY: 'auto', marginTop: 4 }}>
              {searchRes.map(m => (
                <div key={m.id} onClick={() => { setSelected(m); setSearchQ(m.name); setSearchRes([]); }}
                  style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', gap: 10 }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                  onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                  <div style={{ width: 34, height: 34, borderRadius: '50%', background: `linear-gradient(135deg,${M},#b71c1c)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 800, color: G, flexShrink: 0 }}>{m.name[0]}</div>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>{m.name}</div>
                    <div style={{ fontSize: 11, color: '#9ca3af' }}>{[m.village, m.district].filter(Boolean).join(' • ')}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {selected && (
          <>
            <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 10, padding: '10px 14px', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 34, height: 34, borderRadius: '50%', background: `linear-gradient(135deg,${M},#b71c1c)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 800, color: G, flexShrink: 0 }}>{selected.name[0]}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#15803d' }}>✓ {selected.name}</div>
                <div style={{ fontSize: 11, color: '#6b7280' }}>{[selected.village, selected.district].filter(Boolean).join(' • ')}</div>
              </div>
              <button onClick={() => { setSelected(null); setSearchQ(''); }} style={{ background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: 16 }}>✕</button>
            </div>
            <input value={note} onChange={e => setNote(e.target.value)}
              placeholder="संदेश (वैकल्पिक) — कब और कैसे जोड़ा…"
              style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 12px', fontSize: 13, outline: 'none', boxSizing: 'border-box', marginBottom: 12 }} />
          </>
        )}

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: 10, padding: '12px 0', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
            अभी नहीं
          </button>
          <button onClick={send} disabled={!selected || sending}
            style={{ flex: 2, background: selected ? M : '#d1d5db', color: selected ? G : '#9ca3af', border: 'none', borderRadius: 10, padding: '12px 0', fontSize: 14, fontWeight: 800, cursor: selected ? 'pointer' : 'not-allowed' }}>
            {sending ? 'भेज रहे हैं…' : 'अनुरोध भेजें'}
          </button>
        </div>

        <div style={{ marginTop: 12, fontSize: 11, color: '#9ca3af', textAlign: 'center' }}>
          वह सदस्य स्वीकार करेंगे तो आपका रेफरल जुड़ जाएगा • बाद में Refer tab से भी कर सकते हैं
        </div>
      </div>
    </div>
  );
}

// ── Become Member Modal (for directory-only users) ────────────────────────────
export function BecomeMemberModal({ profile, onClose, onSuccess }) {
  const [fatherName,  setFatherName]  = useState('');
  const [amount,      setAmount]      = useState('');
  const [months,      setMonths]      = useState(1);
  const [joining21k,  setJoining21k]  = useState(false);
  const [loading,     setLoading]     = useState(false);
  const [err,         setErr]         = useState('');

  const loadRazorpay = () => new Promise(res => {
    if (window.Razorpay) return res(true);
    const s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.onload = () => res(true); s.onerror = () => res(false);
    document.body.appendChild(s);
  });

  const handlePay = async () => {
    const finalAmount = joining21k ? 200 : parseInt(amount);
    if (!finalAmount || finalAmount < 100) { setErr('मासिक राशि कम से कम ₹100 होनी चाहिए'); return; }
    setErr(''); setLoading(true);
    try {
      const check = await axios.post(`${baseUrl}/member/register/create-order`, {
        name:             profile.name,
        father_name:      fatherName.trim(),
        phone:            profile.phone,
        village:          profile.village || '',
        district:         profile.district || '',
        announced_amount: finalAmount,
        months:           joining21k ? 1 : months,
        campaign:         joining21k ? 'mission_21k' : undefined,
      }, { headers: authHeader() });
      if (!check.data.status) { setErr(check.data.message); setLoading(false); return; }

      const { order_id, amount: totalAmount, months: totalMonths } = check.data;
      await loadRazorpay();
      new window.Razorpay({
        key:      rozerpay_key_id,
        amount:   totalAmount * 100,
        currency: 'INR',
        name:     'ABRSVS — सदस्यता',
        description: joining21k ? 'Mission 21K — ₹200/माह' : `सदस्यता — ${totalMonths} माह`,
        order_id,
        prefill:  { name: profile.name, contact: profile.phone },
        theme:    { color: '#7a0000' },
        handler: async (response) => {
          try {
            const res = await axios.post(`${baseUrl}/member/register/verify-payment`, {
              order_id,
              payment_id: response.razorpay_payment_id,
              signature:  response.razorpay_signature,
              name:       profile.name,
              announced_amount: finalAmount,
              months:     totalMonths,
            });
            if (res.data.status && res.data.token) {
              localStorage.setItem('memberToken', res.data.token);
              localStorage.setItem('memberInfo', JSON.stringify(res.data.member || {}));
              onSuccess();
            } else { setErr(res.data.message || 'Payment failed'); }
          } catch (e) { setErr(e.response?.data?.message || 'Verification failed'); }
          finally { setLoading(false); }
        },
        modal: { ondismiss: () => setLoading(false) },
      }).open();
    } catch (e) { setErr(e.response?.data?.message || 'Error'); setLoading(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: '#fff', borderRadius: 16, width: '100%', maxWidth: 440, maxHeight: '90vh', overflowY: 'auto', padding: '20px 20px 24px' }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 900, color: '#7a0000' }}>ABRSVS सदस्य बनें</div>
            <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>एकबार भुगतान करें — सभी सुविधाएं मिलेंगी</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#9ca3af' }}>×</button>
        </div>

        {/* Pre-filled info */}
        <div style={{ background: '#f8fafc', borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 12 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
            {[['नाम', profile.name], ['मोबाइल', profile.phone], ['गाँव', profile.village || '—'], ['जिला', profile.district || '—']].map(([l, v]) => (
              <div key={l}><span style={{ color: '#9ca3af' }}>{l}: </span><span style={{ fontWeight: 700, color: '#374151' }}>{v}</span></div>
            ))}
          </div>
        </div>

        {/* Father name */}
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>पिता का नाम (optional)</div>
          <input value={fatherName} onChange={e => setFatherName(e.target.value)} placeholder="पिता श्री..."
            style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px', fontSize: 13, boxSizing: 'border-box' }} />
        </div>

        {/* Mission 21K toggle */}
        <div onClick={() => { setJoining21k(p => !p); if (!joining21k) setAmount('200'); }}
          style={{ cursor: 'pointer', borderRadius: 10, padding: '10px 14px', marginBottom: 12,
            background: joining21k ? 'linear-gradient(135deg,#92400e,#b45309)' : '#fef3c7',
            border: `2px solid ${joining21k ? '#fbbf24' : '#fde68a'}`, display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 18 }}>🎯</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: joining21k ? '#fde68a' : '#92400e' }}>Mission 21K में जुड़ें — ₹200/माह</div>
            <div style={{ fontSize: 10, color: joining21k ? 'rgba(255,255,255,0.75)' : '#b45309' }}>
              {joining21k ? '✓ Mission 21K चुना — ₹200 fixed' : 'ABRSVS का सामूहिक सदस्यता अभियान'}
            </div>
          </div>
        </div>

        {/* Amount + months (hidden if mission 21k) */}
        {!joining21k && (
          <>
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>मासिक राशि (₹) *</div>
              <input type="number" min={100} value={amount} onChange={e => setAmount(e.target.value)} placeholder="जैसे: 500"
                style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px', fontSize: 13, boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>कितने माह के लिए?</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 6 }}>
                {[1, 3, 6, 12].map(m => (
                  <button key={m} onClick={() => setMonths(m)}
                    style={{ padding: '8px 4px', borderRadius: 8, border: `2px solid ${months === m ? '#7a0000' : '#e5e7eb'}`,
                      background: months === m ? '#7a0000' : '#fff', color: months === m ? '#FFD700' : '#374151',
                      fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>
                    {m} माह{amount ? `\n₹${(parseInt(amount)||0)*m}` : ''}
                  </button>
                ))}
              </div>
            </div>
          </>
        )}

        {err && <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '8px 12px', fontSize: 12, color: '#dc2626', marginBottom: 12 }}>{err}</div>}

        <button onClick={handlePay} disabled={loading}
          style={{ width: '100%', background: loading ? '#9ca3af' : '#7a0000', color: '#FFD700', border: 'none', borderRadius: 10,
            padding: '13px', fontSize: 14, fontWeight: 900, cursor: loading ? 'not-allowed' : 'pointer' }}>
          {loading ? 'Processing…' : joining21k ? '₹200 Pay करें — Mission 21K Join करें' : `₹${(parseInt(amount)||0) * (joining21k ? 1 : months)} Pay करें — सदस्य बनें`}
        </button>
      </div>
    </div>
  );
}

// ── Festival Celebration Overlay ──────────────────────────────────────────────
export function FestivalCelebration({ festival, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 9000);
    // Play festival sound on show
    playNotifSound('festival');
    return () => clearTimeout(t);
  }, [onClose]);

  const emojis = festival.emojis || ['🎊','🎉','✨','🌸'];
  const bg1 = festival.bg_color_1 || '#7a0000';
  const bg2 = festival.bg_color_2 || '#b71c1c';
  const tc  = festival.text_color || '#FFD700';

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, overflow: 'hidden', pointerEvents: 'none' }}>
      <style>{`
        @keyframes festFall {
          0%   { transform: translateY(-60px) rotate(0deg); opacity: 1; }
          100% { transform: translateY(110vh) rotate(720deg); opacity: 0; }
        }
        @keyframes festPop {
          0%   { transform: scale(0.4) translateY(40px); opacity: 0; }
          65%  { transform: scale(1.06) translateY(0); opacity: 1; }
          100% { transform: scale(1) translateY(0); opacity: 1; }
        }
      `}</style>

      {/* Falling confetti */}
      {[...Array(22)].map((_, i) => (
        <div key={i} style={{
          position: 'absolute', left: `${(i * 4.7) % 100}%`, top: '-60px',
          fontSize: `${13 + (i % 5) * 4}px`,
          animation: `festFall ${2.5 + (i % 6) * 0.5}s linear ${(i * 0.22) % 2.8}s infinite`,
          pointerEvents: 'none', userSelect: 'none',
        }}>{emojis[i % emojis.length]}</div>
      ))}

      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'all' }}>
        <div onClick={e => e.stopPropagation()} style={{
          background: `linear-gradient(160deg, ${bg1} 0%, ${bg2} 100%)`,
          borderRadius: 24, padding: '32px 28px 24px', textAlign: 'center',
          maxWidth: 340, width: '90%',
          boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
          animation: 'festPop 0.55s cubic-bezier(0.34,1.56,0.64,1) forwards',
          position: 'relative', pointerEvents: 'all',
        }}>
          <button onClick={onClose} style={{ position: 'absolute', top: 12, right: 14, background: 'rgba(255,255,255,0.18)', border: 'none', borderRadius: '50%', width: 30, height: 30, color: '#fff', fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
          <div style={{ fontSize: 52, marginBottom: 10 }}>{emojis[0]}</div>
          <div style={{ fontSize: 22, fontWeight: 900, color: tc, fontFamily: 'serif', lineHeight: 1.3, marginBottom: 8 }}>{festival.name}</div>
          {festival.greeting_message && (
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', lineHeight: 1.7, marginBottom: 16 }}>{festival.greeting_message}</div>
          )}
          <div style={{ fontSize: 24, letterSpacing: 3, marginBottom: 16 }}>{emojis.slice(0, 5).join('')}</div>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.18)', border: `1.5px solid rgba(255,255,255,0.4)`, borderRadius: 10, color: '#fff', padding: '9px 26px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            🙏 जय गुरु महाराज री सा
          </button>
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.35)', marginTop: 10 }}>कुछ क्षणों में स्वतः बंद हो जाएगा</div>
        </div>
      </div>
    </div>
  );
}

// ── Birthday Celebration Overlay ──────────────────────────────────────────────
export function BirthdayCelebration({ name, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 8000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, overflow: 'hidden', pointerEvents: 'none' }}>
      <style>{`
        @keyframes fall {
          0%   { transform: translateY(-60px) rotate(0deg); opacity: 1; }
          100% { transform: translateY(110vh)  rotate(360deg); opacity: 0; }
        }
        @keyframes bdPop {
          0%   { transform: scale(0.5) translateY(30px); opacity: 0; }
          60%  { transform: scale(1.08) translateY(0); opacity: 1; }
          100% { transform: scale(1) translateY(0); opacity: 1; }
        }
        @keyframes shimmer {
          0%, 100% { opacity: 1; }
          50%       { opacity: 0.7; }
        }
      `}</style>

      {/* Falling flowers */}
      {FLOWERS.map((f, i) => (
        <div key={i} style={{
          position: 'absolute',
          left: `${(i * 5.2) % 100}%`,
          top: '-60px',
          fontSize: `${14 + (i % 4) * 5}px`,
          animation: `fall ${2.8 + (i % 5) * 0.6}s linear ${(i * 0.28) % 2.5}s infinite`,
          pointerEvents: 'none',
          userSelect: 'none',
        }}>{f}</div>
      ))}

      {/* Backdrop + card — clickable */}
      <div onClick={onClose} style={{
        position: 'absolute', inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        pointerEvents: 'all',
      }}>
        <div onClick={e => e.stopPropagation()} style={{
          background: 'linear-gradient(160deg, #7c1d6f 0%, #9d174d 40%, #7c3aed 100%)',
          borderRadius: 24, padding: '36px 32px 28px',
          textAlign: 'center', maxWidth: 340, width: '90%',
          boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
          animation: 'bdPop 0.55s cubic-bezier(0.34,1.56,0.64,1) forwards',
          position: 'relative', pointerEvents: 'all',
        }}>
          {/* Close */}
          <button onClick={onClose} style={{
            position: 'absolute', top: 12, right: 14,
            background: 'rgba(255,255,255,0.15)', border: 'none',
            borderRadius: '50%', width: 30, height: 30,
            color: '#fff', fontSize: 16, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>×</button>

          {/* Auspicious symbol */}
          <div style={{ fontSize: 64, marginBottom: 8, animation: 'shimmer 1.5s ease-in-out infinite' }}>🌸</div>

          <div style={{ fontSize: 22, fontWeight: 900, color: '#FFD700', marginBottom: 6, fontFamily: 'serif', lineHeight: 1.3 }}>
            जन्मदिन की<br />हार्दिक शुभकामनाएं!
          </div>

          <div style={{ fontSize: 16, fontWeight: 800, color: '#fff', marginBottom: 4 }}>
            🌸 {name} जी 🌸
          </div>

          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)', lineHeight: 1.7, marginBottom: 20 }}>
            श्री खेतेश्वर महाराज की कृपा से<br />
            आपका यह वर्ष शुभ, सुखमय एवं<br />
            मंगलमय हो। 🙏
          </div>

          <div style={{ fontSize: 28, letterSpacing: 4, marginBottom: 16 }}>🌺🌸🌼🌷🌺</div>

          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.2)', border: '1.5px solid rgba(255,255,255,0.5)',
            borderRadius: 10, color: '#fff', padding: '10px 28px',
            fontSize: 13, fontWeight: 700, cursor: 'pointer', letterSpacing: 0.5,
          }}>
            🙏 धन्यवाद
          </button>

          {/* Auto-close hint */}
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', marginTop: 10 }}>
            कुछ क्षणों में स्वतः बंद हो जाएगा
          </div>
        </div>
      </div>
    </div>
  );
}
